import { toExceptionDetail } from 'src/models/ExceptionDetail';

export const buildCaseAuthorityException = (error) => {
  return toExceptionDetail(error);
};
